import { useDialog } from '@/components/Molecules/Dialog/Dialog';
import { useEffect, useState } from 'react';

const DEFAULT_MAX_ITEMS = 3;
const DEFAULT_BUFFER = 2;

export const useTruncatedList = (items: any[]) => {
    const dialog = useDialog({ lazy: true });
    const [truncated, setTruncated] = useState<boolean>();
    const totalCount = items.length;

    useEffect(() => {
        // hide items only on mount (progressive enhancement)
        const isOverflowing = totalCount > DEFAULT_MAX_ITEMS + DEFAULT_BUFFER;
        setTruncated(isOverflowing);
    }, [items]);

    const itemsToRender = items.slice(0, truncated ? DEFAULT_MAX_ITEMS : totalCount);

    return {
        dialog,
        truncated,
        itemsToRender,
        totalCount,
    };
};
